import { Injectable, Injector } from "@angular/core";
import { environment } from "@environments/environment";
import { Service } from "@services/service";

@Injectable()
export class PurchaseLogLineItemAllocationService extends Service {
	constructor(injector: Injector) {
		super("PurchaseLogLineItemAllocation", injector);
	}

	// API
	getByPurchaseLogId(id: number) {
		return this.http.get(`${environment.server.apiURL}/${this.endpoint}/GetByPurchaseLogId/${id}`);
	}
}